<template>
  <div class="topic_container">
    <div class="topic_title">
      选择话题
    </div>

    <div class="topic_body">
      <div :class="['topic_item']" @click="choiceTopic({name:'不选择任何话题',id:null})">
        <i class="iconfont iconGroup2" style="font-size: 11px"></i>&nbsp;&nbsp;不选择任何话题
      </div>
      <div v-for="item in topicList" :class="['topic_item',item.id==topicId?'active':'']" @click="choiceTopic(item)">#&nbsp;&nbsp;&nbsp;{{item.name}}</div>
    </div>
  </div>
</template>

<script>
  import bbs from '../../../api/api-list/bbs'

  export default {
    name: "topic-list",
    props: {
      topicList: Array,
      topicId: Number
    },
    data() {
      return {
        // topicList:[],
      }
    },
    mounted() {
      // this.getAllTopic();
    },
    methods: {
      // 选择话题
      choiceTopic(obj) {
        this.$emit('choiceTopic', obj)
      },
    },
    watch: {}
  }
</script>

<style lang="scss" scoped>
  .topic_container {
    width: 100%;
    height: 495px;
    background-color: #fff;
    border-radius: 16px 16px 0 0;
    padding: 0 24px;
    color: #404040;

    .topic_title {
      width: 100%;
      height: 60px;
      font-size: 16px;
      line-height: 60px;
      text-align: center;
      font-weight: bold;
    }

    .topic_item {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #f9f9f9;
    }

    .topic_body {
      width: 100%;
      height: calc(100% - 60px);
      overflow: auto;

      .topic_item {
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #f9f9f9;
      }

      .active {
        color: #FF6644;
      }
    }
  }
</style>
